import * as React from "react";
import * as ReactDOM from "react-dom";
import { CustomComponent, ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";

import { InstantSearch } from "@app/scripts/reactify/instant-search/components/InstantSearch";
import { isKids, tagFilterKids, tagFilterMens } from "@app/scripts/utils/tagFilters";

const isKidsOnly = isKids();

const ReactifySearchFactory = new ReactifySearchLiquidFactory({
  mode: "instant-search",
  additionalComponentIds: ["TagFilter"],
});

const ReactifySearchProvider = ReactifySearchFactory.getProvider();
const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

ReactDOM.render(
  <React.StrictMode>
    <ReactifySearchProvider>
      <CustomComponent
        componentId="TagFilter"
        customQuery={() => ({
          query: {
            ...(isKidsOnly ? tagFilterKids : tagFilterMens),
          },
        })}
      />
      <Sensors />
      <InstantSearch />
    </ReactifySearchProvider>
  </React.StrictMode>,
  ReactifySearchMountNode
);
